@if ($pageContent | async) {
<ng-container #container></ng-container>
}
